import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { cloneElement, Fragment, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { FadeReveal } from '../FadeReveal/index';
import { Icon, } from '../Icon/index';
import { IconButton, } from '../IconButton/index';
import { AlertContainer } from './AlertContainer';
import { alignments, types, } from './constants';
const alertIcons = {
    [types.informative]: 'info',
    [types.negative]: 'error',
    [types.notice]: 'warning',
    [types.positive]: 'info',
};
const buttonContainerStyles = css `
  align-self: center;
  flex-shrink: 0;
  padding-left: ${theme.spacing.x2};
`;
const childrenContainerStyles = css `
  background-color: ${theme.colors.gray100};
`;
const closeButtonStyles = css `
  padding-left: ${theme.spacing.x2};
`;
const iconStyles = css `
  display: inline-flex;
  padding-right: ${theme.spacing.x2};
`;
const wrapperStyles = css `
  position: relative;

  &.enter {
    max-height: 0;
    opacity: 0;
  }

  &.enter.enterActive {
    ${styleUtils.transition('all')}
    max-height: ${styleUtils.rem(110)};
    opacity: 1;
  }

  &.exit {
    max-height: ${styleUtils.rem(110)};
    opacity: 1;
  }

  &.exit.exitActive {
    ${styleUtils.transition('all')}
    max-height: 0;
    opacity: 0;
  }
`;
const defaultProps = {
    alignment: alignments.left,
    onCloseClick: undefined,
    type: types.informative,
};
const Alert = ({ alignment = defaultProps.alignment, button, children, iconType, onCloseClick = defaultProps.onCloseClick, primaryText, secondaryText, show, type = defaultProps.type, }) => {
    const isIconVisible = useMemo(() => (alignment !== alignments.center
        && iconType !== 'none'), [
        alignment,
        iconType,
    ]);
    const messageStyles = useMemo(() => (css `
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        ${alignment === alignments.center && css `text-align: center;`}
        padding-top: calc(${theme.spacing.base} / 2);
      `), [
        alignment,
    ]);
    const primaryTextStyles = useMemo(() => (css `
        ${theme.typeStyles.titleSmallStyles}
        ${secondaryText && css `
          padding-bottom: ${theme.spacing.base};
        `}
      `), [
        secondaryText,
    ]);
    return (_jsx(Fragment, { children: _jsx(FadeReveal, Object.assign({ in: show, unmountOnExit: true }, { children: _jsxs("div", Object.assign({ css: wrapperStyles }, { children: [_jsxs(AlertContainer, Object.assign({ alignment: alignment, type: type }, { children: [isIconVisible
                                && (_jsx("div", Object.assign({ css: iconStyles }, { children: _jsx(Icon, { size: "small", type: iconType || alertIcons[type] }) }))), _jsxs("div", Object.assign({ css: messageStyles }, { children: [primaryText
                                        && (_jsx("div", Object.assign({ css: primaryTextStyles }, { children: primaryText }))), secondaryText
                                        && (_jsx("div", Object.assign({ css: theme.typeStyles.bodySmallStyles }, { children: secondaryText })))] })), button
                                && (_jsx("div", Object.assign({ css: buttonContainerStyles }, { children: cloneElement(button, {
                                        size: 'medium',
                                    }) }))), onCloseClick
                                && (_jsx("div", Object.assign({ css: closeButtonStyles }, { children: _jsx(IconButton, { iconType: "close", label: "close", onClick: onCloseClick, size: "medium", type: "secondary" }) })))] })), children && (_jsx("div", Object.assign({ css: childrenContainerStyles }, { children: children })))] })) })) }));
};
export { Alert };
